import { useTranslation } from "react-i18next";

import andrea from "../assets/istruttori/cestaro.png";
import daniele from "../assets/istruttori/adami.png";
import clizia from "../assets/istruttori/buniotto.png";
import matteo from "../assets/istruttori/soave.png";
import zeno from "../assets/istruttori/toffalini.png";

function CardIstruttore({ name, description, titles, image }) {
  return (
    <div className="profile-card">
      <h3 className="profile-name">{name}</h3>
      <img className="profile-image" src={image} alt={name} />
      <ul>
        {titles.map((title, idx) => (
          <li key={idx} className="profile-description">
            {title}
          </li>
        ))}
      </ul>
      {/* <p className="profile-title">{titles}</p> */}
      <p className="mt-5 profile-description">{description}</p>
    </div>
  );
}

function IstruttoriDetail() {
  const { t } = useTranslation();

  return (
    <section id="istruttori" className="instructors-section">
      <div>
        <div className="instructors-header">
          <h2 className="base-title">{t("istruttori.titleDetail")}</h2>
        </div>

        <div className="istruttori-text-container">
          {t("istruttori.description", { returnObjects: true }).map(
            (text, index) => (
              <p key={index} className="mb-4">
                {text}
              </p>
            ),
          )}
        </div>

        <div className="instructors-grid-2">
          <CardIstruttore
            name="Daniele Adami"
            description={t("istruttori.andrea.description")}
            titles={t("istruttori.daniele.titles", {
              returnObjects: true,
            })}
            image={daniele}
          />
          <CardIstruttore
            name="Andrea Cestaro"
            description={t("istruttori.andrea.description")}
            titles={t("istruttori.andrea.titles", {
              returnObjects: true,
            })}
            image={andrea}
          />
        </div>

        <div className="instructors-grid-3">
          <CardIstruttore
            name="Clizia Buniotto"
            description={t("istruttori.clizia.description")}
            titles={t("istruttori.clizia.titles", {
              returnObjects: true,
            })}
            image={clizia}
          />
          <CardIstruttore
            name="Zeno Toffalini"
            description={t("istruttori.zeno.description")}
            titles={t("istruttori.zeno.titles", { returnObjects: true })}
            image={zeno}
          />
          <CardIstruttore
            name="Matteo Soave"
            description={t("istruttori.matteo.description")}
            titles={t("istruttori.matteo.titles", {
              returnObjects: true,
            })}
            image={matteo}
          />
        </div>
      </div>
    </section>
  );
}

export default IstruttoriDetail;
